"use strict";

import { creditCardConstants } from "../_constants";
import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import {
  ajaxError,
  creditCardCashbackDetailsComplete,
  creditCardCashbackDetailsError,
  creditCardStatementDetailsComplete,
  creditCardStatementDetailsError,
  creditCardStatementListComplete,
  creditCardStatementListError,
  creditCardSupplementaryDetailsComplete,
  creditCardSupplementaryDetailsError,
  creditCardTransactionListComplete,
  creditCardTransactionListError,
  debitCardDetailsComplete,
  debitCardDetailsError,
  debitCardTransactionHistoryComplete,
  debitCardTransactionHistoryError,
} from "../_actions";

export const creditCardCashbackDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getCashbackDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardCashbackDetailsComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardCashbackDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const creditCardTransactionListsEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getTransactionList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardTransactionListComplete({
              ...ajaxResponse.response,
              billingStatus: action.payload.billingStatus,
            }),
          ),
          catchError((error) =>
            of(
              creditCardTransactionListError({
                ...error,
                billingStatus: action.payload.billingStatus,
              }),
              ajaxError(error),
            ),
          ),
        );
    }),
  );

export const creditCardStatementListsEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.CREDIT_CARD_STATEMENT_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getStatementList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardStatementListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardStatementListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const creditCardStatementDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getStatementDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardStatementDetailsComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardStatementDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const creditCardSupplementaryDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getSupplementaryDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardSupplementaryDetailsComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardSupplementaryDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const debitCardDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.DEBIT_CARD_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getDebitCardDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return debitCardDetailsComplete(ajaxResponse.response);
          }),
          catchError((error) => {
            return of(debitCardDetailsError(error), ajaxError(error));
          }),
        );
    }),
  );

export const debitCardTransactionHistoryEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCard/getDebitCardTransactionHistory",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return debitCardTransactionHistoryComplete(ajaxResponse.response);
          }),
          catchError((error) => {
            return of(
              debitCardTransactionHistoryError(error),
              ajaxError(error),
            );
          }),
        );
    }),
  );
